import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { isDesktop, useDemoAnalytics } from '@carboncopyco/utils';
import { NotesInDesktopMessage, SpeakerNotesCard } from '../../../SpeakerNotes';
import { usePermissionsContext } from '../../../utils';
import { useOverlayPageProps } from '../OverlayPageContext';
import { OverlayTabLayout } from '../OverlayTabLayout';

export const SpeakerNotesTab = () => {
  const {
    demoId,
    showNotesInDesktopMessage,
    onCloseNotesInDesktopMessage,
    noteValue,
    setNoteValue,
    readOnly,
  } = useOverlayPageProps();

  const { getPermissions } = usePermissionsContext();
  const userHasNoteEditingPermission = getPermissions(
    PermissionKey.note,
    PermissionAction.updateNoteById
  );

  const { trackDemoAddSpeakerNotes } = useDemoAnalytics(
    'overlay_page_speaker_notes_tab'
  );

  return (
    <OverlayTabLayout>
      <div className="h-full flex flex-col pb-10">
        {!isDesktop() && showNotesInDesktopMessage && (
          <NotesInDesktopMessage onClose={onCloseNotesInDesktopMessage} />
        )}
        <div className="grow">
          <SpeakerNotesCard
            isEditable={!readOnly && userHasNoteEditingPermission}
            entityId={String(demoId)}
            entityType="demo"
            value={noteValue}
            setValue={setNoteValue}
            onAddNote={() => {
              trackDemoAddSpeakerNotes({ demoId });
            }}
          />
        </div>
      </div>
    </OverlayTabLayout>
  );
};
